const D = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1280
}, h = ["en", "fr", "it"], l = ["cms", "destination", "footer", "navigation-bar", "sitemaps", "auth", "search"], m = ["navigation-bar:open-signup-modal"];
function p(e) {
  return new Date(e).toLocaleDateString();
}
function a(e, n) {
  const t = new Date(e);
  return t.setDate(t.getDate() + n), t;
}
function E(e, n) {
  const t = n.getTime() - e.getTime();
  return Math.round(t / (1e3 * 3600 * 24));
}
const S = (e) => {
  const n = e.getFullYear(), t = String(e.getMonth() + 1).padStart(2, "0"), r = String(e.getDate()).padStart(2, "0");
  return `${n}-${t}-${r}`;
}, w = (e, n) => e.getDate() === n.getDate() && e.getMonth() === n.getMonth() && e.getFullYear() === n.getFullYear(), g = (e, n, t) => e >= n && e <= t, T = (e, n) => {
  const t = e.sort(({ start: c }, { start: s }) => c.getTime() - s.getTime()), r = [], o = /* @__PURE__ */ new Date(), i = n || /* @__PURE__ */ new Date("01-01-9999");
  if (t.length === 0)
    r.push({
      start: o,
      end: i
    });
  else {
    if (!g(o, t[0].start, t[0].end)) {
      const s = t[0].start;
      r.push({
        start: o,
        end: a(s, -1)
      });
    }
    for (let s = 0; s < t.length - 1; s++) {
      const u = t[s].end, d = t[s + 1].start;
      r.push({
        start: a(u, 1),
        end: a(d, -1)
      });
    }
    const c = t[t.length - 1].end;
    r.push({
      start: a(c, 1),
      end: i
    });
  }
  return r;
}, _ = (e, n) => {
  let t;
  return () => {
    clearTimeout(t), t = setTimeout(e, n);
  };
};
function v(e) {
  window && window.dispatchEvent(new Event(e));
}
function k() {
  return typeof window < "u" && typeof document < "u";
}
const f = (e, n) => e.split(";").map((t) => t.split("=")).filter(([t]) => !n || n.includes(t.trim())).reduce(
  (t, [r, o]) => (t[r.trim()] = o.trim(), t),
  {}
), M = ({ access_token: e, refresh_token: n } = {}) => {
  const t = {}, r = f(document.cookie, ["access_token", "refresh_token"]);
  return t.Authorization = `Bearer ${e ?? r.access_token}`, (r.refresh_token || n) && (t.refresh_token = n ?? r.refresh_token), t;
}, y = (e = {}) => {
  const n = {};
  return e.access_token && (n.Authorization = `Bearer ${e.access_token}`), n;
};
export {
  D as BREAKPOINTS,
  m as EVENTS_HE,
  h as LOCALIZED_DOMAINS,
  l as MODULES_HE,
  a as addDaysToDate,
  E as calculateDaysDifference,
  S as convertDateToISODateString,
  _ as debounce,
  v as dispatchEvent,
  p as formatDateToLocale,
  M as getHeaders,
  T as getReverseRanges,
  y as getServerHeaders,
  g as isBetween,
  k as isBrowser,
  w as isSameDay,
  f as parseCookies
};
